var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestartDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM18.5157 5.41667H7.48462C6.94111 5.41667 6.5 5.85479 6.5 6.39535V20.688C6.5 21.2285 6.94111 21.6667 7.48462 21.6667H18.5154C19.0592 21.6667 19.5 21.2285 19.5 20.688V6.39535C19.5003 5.85511 19.0595 5.41667 18.5157 5.41667ZM13.0002 20.6557C12.583 20.6557 12.245 20.3197 12.245 19.905C12.245 19.4904 12.583 19.1544 13.0002 19.1544C13.417 19.1544 13.7554 19.4904 13.7554 19.905C13.7554 20.3194 13.417 20.6557 13.0002 20.6557ZM18.0887 17.2297C18.0887 17.7702 17.6479 18.2083 17.1041 18.2083H8.89658C8.35274 18.2083 7.91195 17.7702 7.91195 17.2297V8.0927C7.91195 7.55215 8.35274 7.11402 8.89658 7.11402H17.1041C17.6479 7.11402 18.0887 7.55215 18.0887 8.0927V17.2297ZM12.998 9.75C13.8963 9.75 14.7053 10.1156 15.2947 10.7047L16.25 9.75V12.5938H13.4045L14.7134 11.2856C14.2744 10.8428 13.6728 10.5625 12.998 10.5625C11.6524 10.5625 10.5589 11.6553 10.5589 13C10.5589 14.3447 11.6524 15.4375 12.998 15.4375C14.0589 15.4375 14.9614 14.7591 15.2947 13.8125H16.1402C15.7785 15.2141 14.5142 16.25 12.998 16.25C11.2012 16.25 9.75 14.7956 9.75 13C9.75 11.2044 11.2012 9.75 12.998 9.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartDevice);
export default __webpack_public_path__ + "static/media/restart_device.a26154d2fca382a6047869b55d900d94.svg";
export { ForwardRef as ReactComponent };